/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="16"
        height="18"
        viewBox="0 0 16 18"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M3.73 0v1.5h8.46V0h1v1.5h2.83V18h-16V1.5h2.77V0Zm11.32 5.5H.95V17h14.1Zm-7.86 8v1.53H5.61V13.5Zm-3.1 0v1.53H2.51V13.5Zm6.23 0v1.53H8.74V13.5Zm3.12 0v1.53h-1.58V13.5Zm-6.25-3v1.54H5.61V10.5Zm-3.1 0v1.54H2.51V10.5Zm6.23 0v1.54H8.74V10.5Zm3.12 0v1.54h-1.58V10.5Zm-3.11-3v1.54H8.74V7.5Zm-3.14 0v1.54H5.61V7.5Zm6.26 0v1.54h-1.58V7.5Zm1.59-5h-1.85v1.19h-1V2.5H3.7v1.19h-.95V2.5H.93v2.08h14.1Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'CalendarIcon';

export default Icon;
